
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaicarhire() {



    const cardData =
    {
        keyword: 'Pune Mumbai Car Hire',
        heading: 'Skyline Cabs: Pune Mumbai Car Hire',
        headingDescription: 'Skyline Cabs offers premium Pune Mumbai Car Hire services for your travel needs. Whether you’re planning a business trip, vacation, or simply need a reliable ride between Pune and Mumbai, our car hire service provides comfort, convenience, and affordability. Choose from a range of well-maintained vehicles and enjoy a smooth, safe, and timely journey with our professional drivers. Book your Pune Mumbai Car Hire today and experience hassle-free travel with Skyline Cabs.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Marine Drive",
        "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
    },
    {
        "title": "Elephanta Caves",
        "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
    },
    {
        "title": "Juhu Beach",
        "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Mumbai Pune Car Rental Services",
      "description": "Skyline Cabs offers reliable car rental services for your journey from Mumbai to Pune. Whether you’re planning a business trip or a personal getaway, choose from our wide range of vehicles including sedans, Ertiga, and Innova. Enjoy professional service, transparent pricing, and a smooth ride."
    },
    {
      "name": "Pune Mumbai Pune Car Rental",
      "description": "Planning a round trip? Skyline Cabs provides convenient Pune–Mumbai–Pune car rental options with flexible booking and well-maintained vehicles. Our round-trip rentals are ideal for same-day returns, extended stays, or corporate travels, with experienced drivers who know the routes well."
    },
    {
      "name": "Pune Mumbai Innova Rental",
      "description": "Looking for a comfortable and spacious vehicle for your Pune-Mumbai journey? Rent an Innova with Skyline Cabs for a smooth ride. Ideal for families, group travelers, or business trips, our Innova rentals combine comfort, reliability, and luxury."
    },
    {
      "name": "Pune Mumbai Skyline Cabs Car Hire",
      "description": "Skyline Cabs offers premium car hire services between Pune and Mumbai. Choose from a fleet of well-maintained vehicles including Innova, Ertiga, sedans, and SUVs. With professional drivers and 24/7 support, we ensure your travel is safe, punctual, and relaxing."
    },
    {
      "name": "Pune to Mumbai Cab Hire",
      "description": "Hire a cab from Pune to Mumbai with Skyline Cabs for a stress-free travel experience. Our cab hire services come with experienced drivers, clean vehicles, and competitive rates. Book one-way, round-trip, or airport transfers easily online or via call."
    },
    {
      "name": "Pune to Mumbai Drop Cab",
      "description": "Need a drop to Mumbai from Pune? Skyline Cabs provides punctual and affordable cab drop services. Perfect for airport runs, meetings, or city visits, we ensure a comfortable and timely drop with zero hassles. Choose from various car options as per your travel style."
    },
    {
      "name": "Pune to Mumbai Private Cab",
      "description": "Enjoy privacy and convenience with Skyline’s private cab services from Pune to Mumbai. Our cabs are perfect for families, executives, or couples looking for a dedicated ride. We offer flexible timing, professional drivers, and clean, air-conditioned vehicles."
    },
    {
      "name": "Pune to Mumbai Taxi Booking",
      "description": "Book your Pune to Mumbai taxi with Skyline Cabs in just a few clicks. Our easy online booking system ensures a hassle-free reservation. With multiple vehicle options and transparent pricing, your journey will be smooth, safe, and punctual."
    },
    {
      "name": "Pune Mumbai Airport Car Rental",
      "description": "Skyline Cabs provides car rental services for convenient travel between Pune and Mumbai Airport. Whether it's a pickup or drop-off, our vehicles are well-maintained and equipped for airport travel, with space for luggage and timely service guaranteed."
    },
    {
      "name": "Pune to Mumbai Darshan Cab",
      "description": "Explore Mumbai with Skyline Cabs’ special Darshan packages from Pune. Our cabs are available for sightseeing tours, temple visits, and family outings. Choose a vehicle that suits your group and enjoy a full-day or half-day package with a knowledgeable driver."
    },
    {
      "name": "Pune to Mumbai Car Rental",
      "description": "Skyline Cabs offers flexible car rental options from Pune to Mumbai. Whether you're booking for a one-way trip or planning to return, we provide a range of car types and customizable rental durations. Experience a convenient and budget-friendly ride."
    },
    {
      "name": "Pune to Mumbai Car Booking",
      "description": "With Skyline Cabs, car booking from Pune to Mumbai is seamless and quick. Choose from a variety of models and travel with professional drivers who ensure safety and comfort. Ideal for solo trips, families, or business travelers."
    },
    {
      "name": "Pune to Mumbai Car on Rent",
      "description": "Get a car on rent with Skyline Cabs for your Pune to Mumbai travel. Our services are reliable, cost-effective, and perfect for both short and long-distance travel. Book a vehicle that matches your preferences and enjoy a comfortable journey."
    },
    {
      "name": "Pune to Mumbai Car Hire Charges",
      "description": "Skyline Cabs offers transparent car hire charges for your Pune to Mumbai trip. Our pricing is based on distance, car type, and trip duration. Contact us for a custom quote and enjoy high-quality service at affordable rates."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Travel comfortably with an Ertiga cab from Pune to Mumbai, courtesy of Skyline Cabs. Perfect for families and small groups, the Ertiga offers ample space and air-conditioned interiors for a relaxed and budget-friendly ride."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Skyline Cabs provides Innova cab services from Pune to Mumbai for those who seek extra space and comfort. With plush interiors and smooth handling, the Innova is perfect for long-distance travel with family, friends, or corporate teams."
    },
    {
      "name": "Pune Mumbai Car Rental",
      "description": "Skyline Cabs specializes in car rentals between Pune and Mumbai. Choose from sedans, Ertiga, Innova, and luxury cars. Whether you need a ride for a few hours or a full day, our services are flexible, dependable, and affordable."
    },
    {
      "name": "Pune to Mumbai Cab",
      "description": "Book a Pune to Mumbai cab with Skyline Cabs for a reliable and smooth journey. Our services include door-to-door pickup, experienced drivers, and a variety of vehicle options. Perfect for all types of travelers, from solo rides to group bookings."
    },
    {
      "name": "One Way Cab Pune to Mumbai",
      "description": "Skyline Cabs offers one-way cab services from Pune to Mumbai, ideal for airport transfers, business trips, or weekend getaways. Our fleet includes sedans, Ertiga, and Innova, all driven by courteous and professional drivers."
    },
    {
      "name": "Pune to Mumbai Cheapest Cab",
      "description": "Travel affordably with Skyline Cabs' cheapest cab options from Pune to Mumbai. We offer economical fares without compromising on comfort or service quality. Choose from hatchbacks, sedans, or shared cab services to save on travel."
    },
    {
      "name": "Pune to Mumbai Cab Fare",
      "description": "Our Pune to Mumbai cab fares at Skyline Cabs are transparent and fairly priced. No hidden charges—just competitive rates tailored to your travel distance and vehicle choice. Contact us for a detailed quote."
    },
    {
      "name": "Pune to Mumbai Cab Charges",
      "description": "Skyline Cabs provides affordable cab charges for Pune to Mumbai trips. Choose from various vehicle options with upfront pricing. Whether it's a one-way, round trip, or airport drop, we offer rates that suit every budget."
    },
    {
      "name": "Pune to Mumbai Cab Price",
      "description": "Get the best price on Pune to Mumbai cabs with Skyline Cabs. Our competitive pricing ensures you get great value for money without compromising on safety or comfort. Contact us for deals and current rates."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "For a premium travel experience, Skyline Cabs offers Innova cab rentals from Pune to Mumbai. Spacious, stylish, and reliable, it's ideal for long journeys, family travel, or corporate use."
    },
    {
      "name": "Pune to Mumbai Taxi One Way",
      "description": "Book a one-way taxi from Pune to Mumbai with Skyline Cabs for a reliable and stress-free trip. With easy online booking, transparent pricing, and a fleet of well-maintained cars, we make your journey seamless."
    },
    {
      "name": "Pune to Mumbai Cab Booking",
      "description": "Easily book your cab from Pune to Mumbai with Skyline Cabs. Whether you're booking in advance or need a last-minute ride, our system is fast and convenient, with a range of vehicle options to choose from."
    },
    {
      "name": "Pune Mumbai Cabs",
      "description": "Skyline Cabs provides dependable and comfortable cab services between Pune and Mumbai. Whether it’s for business, airport transfers, or sightseeing, our cabs are clean, punctual, and available 24/7."
    },
    {
      "name": "Pune to Mumbai Airport Drop Innova",
      "description": "Need an airport drop in comfort? Skyline Cabs offers Innova vehicles for airport transfers from Pune to Mumbai. Spacious and ideal for travelers with luggage, our Innova drops ensure a smooth and timely ride to your terminal."
    },
    {
      "name": "Pune Mumbai Pune Cab",
      "description": "Skyline Cabs offers round-trip cab services between Pune and Mumbai. Whether it's for a day-long business trip or weekend getaway, enjoy reliable service with professional drivers and well-maintained cars."
    },
    {
      "name": "Pune to Mumbai Airport Cabs",
      "description": "Travel to Mumbai Airport from Pune with Skyline Cabs’ dedicated airport cab service. Choose from Ertiga, Innova, sedans, or luxury options for a comfortable, on-time ride. Booking is quick and service is professional."
    }
  ],

  "tableData": [
    ["Mumbai Pune Car Rental Services", "-Pune Mumbai Pune Car Rental"],
    ["Pune Mumbai Innova Rental", "-Pune Mumbai Skyline Cabs Car Hire"],
    ["Pune to Mumbai Cab Hire", "-Pune to Mumbai Drop Cab"],
    ["Pune to Mumbai Private Cab", "-Pune to Mumbai Taxi Booking"],
    ["Pune Mumbai Airport Car Rental", "-Pune to Mumbai Darshan Cab"],
    ["Pune to Mumbai Car Rental", "-Pune to Mumbai Car Booking"],
    ["Pune to Mumbai Car on Rent", "-Pune to Mumbai Car Hire Charges"],
    ["Pune to Mumbai Ertiga Cab", "-Pune to Mumbai Innova Cab"],
    ["Pune Mumbai Car Rental", "-Pune to Mumbai Cab"],
    ["One Way Cab Pune to Mumbai", "-Pune to Mumbai Cheapest Cab"],
    ["Pune to Mumbai Cab Fare", "-Pune to Mumbai Cab Charges"],
    ["Pune to Mumbai Cab Price", "-Pune to Mumbai Innova Cab"],
    ["Pune to Mumbai Taxi One Way", "-Pune to Mumbai Cab Booking"],
    ["Pune Mumbai Cabs", "-Pune to Mumbai Airport Drop Innova"],
    ["Pune Mumbai Pune Cab", "-Pune to Mumbai Airport Cabs"]
  ],

  whychoose: [
    {
        "WhyChooseheading": "Trusted Pune Mumbai Car Hire Services",
        "WhyChoosedescription": "Skyline Cabs offers reliable and flexible car hire options for travel between Pune and Mumbai. Whether you're planning a business trip, a family outing, or a solo ride, our car hire service ensures you get a dependable vehicle and professional service tailored to your needs."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles to Suit Every Traveler",
        "WhyChoosedescription": "From budget-friendly sedans to premium SUVs and luxury cars, we offer a diverse fleet to meet every preference and requirement. Whether you’re traveling light or need space for luggage and companions, our vehicles are clean, spacious, and perfect for a comfortable intercity drive."
    },
    {
        "WhyChooseheading": "Professional Drivers with Local Expertise",
        "WhyChoosedescription": "Our drivers are courteous, experienced, and well-versed in the Pune to Mumbai route. They not only ensure safe and smooth driving but also help navigate traffic and road conditions to get you to your destination efficiently and on time."
    },
    {
        "WhyChooseheading": "Flexible Car Hire Plans with Transparent Pricing",
        "WhyChoosedescription": "With Skyline Cabs, you get clear and honest pricing—no hidden charges or confusing rate cards. Choose from hourly, one-way, or full-day hire options and pay only for what you need. All charges are upfront, so you can plan your trip without budget surprises."
    },
    {
        "WhyChooseheading": "24/7 Car Hire Availability",
        "WhyChoosedescription": "Need a car early in the morning, late at night, or at the last minute? No worries—Skyline Cabs is available round the clock to serve you. Our Pune Mumbai car hire services are always on standby to fit your travel schedule, however tight or spontaneous it may be."
    },
    {
        "WhyChooseheading": "Well-Maintained Cars for a Smooth Ride",
        "WhyChoosedescription": "All our cars undergo routine checks, servicing, and deep cleaning. This ensures a safe, smooth, and enjoyable ride every time. Whether it's a short trip or a long drive, our well-maintained fleet keeps your journey hassle-free."
    },
    {
        "WhyChooseheading": "Simple Booking Process with Instant Confirmation",
        "WhyChoosedescription": "Hiring a car from Pune to Mumbai has never been easier. Just visit our website, use our mobile app, or call our support team to make a booking. Get instant confirmation, clear fare details, and your cab at your doorstep right on time."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Travel Experience",
        "WhyChoosedescription": "Safety is a top priority at Skyline Cabs. All our vehicles are GPS-enabled, and our drivers are vetted for safety and professionalism. With plush seating, climate control, and smooth handling, your ride from Pune to Mumbai will be both secure and relaxing."
    }
]






    }


    const faqData = [
        {
            id: 1,
            question: 'How can I hire a car from Pune to Mumbai with Skyline Cabs?',
            answer:
                'Hiring a car with Skyline Cabs is easy! You can book your ride through our website, mobile app, or by calling our customer support team for assistance. We offer flexible rental packages to suit your needs.',
        },
        {
            id: 2,
            question: 'What types of cars are available for hire from Pune to Mumbai?',
            answer:
                'Skyline Cabs offers a range of vehicles for hire including compact cars, sedans, SUVs, and luxury vehicles. All our cars are well-maintained and equipped with modern amenities for a comfortable journey.',
        },
        {
            id: 3,
            question: 'Are Skyline Cabs drivers experienced for long-distance car hires?',
            answer:
                'Yes, our drivers are highly experienced and well-trained in handling long-distance routes like Pune to Mumbai. They ensure your ride is smooth, safe, and comfortable throughout the journey.',
        },
        {
            id: 4,
            question: 'What payment methods are available for hiring a car from Pune to Mumbai?',
            answer:
                'We accept a wide variety of payment methods including cash, credit/debit cards, UPI, and secure online payments through our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I hire a car for a round trip from Pune to Mumbai?',
            answer:
                'Yes, we offer both one-way and round-trip car hire services. If you need a return ride from Mumbai, simply provide your return details during the booking process.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for detours or waiting time?',
            answer:
                'We follow a transparent pricing structure. Any additional charges for detours or waiting time will be communicated to you in advance before confirming your booking, so there are no surprises.',
        },
        {
            id: 7,
            question: 'Can I hire a car for sightseeing during my trip from Pune to Mumbai?',
            answer:
                'Yes, we offer customized sightseeing packages along the Pune to Mumbai route. You can visit popular spots along the way, and we’ll ensure a comfortable journey with a knowledgeable driver.',
        },
        {
            id: 8,
            question: 'What’s the luggage allowance for a car hire between Pune and Mumbai?',
            answer:
                'Our vehicles can accommodate standard luggage. If you have more baggage or specific requirements, please inform us during the booking process, and we’ll provide a suitable vehicle.',
        },
        {
            id: 9,
            question: 'Do you provide corporate car hire services between Pune and Mumbai?',
            answer:
                'Yes, we offer corporate car hire services, including customized solutions for business meetings, conferences, and team outings. You can book a car as per your specific needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for Pune Mumbai car hire?',
            answer:
                'Skyline Cabs is known for its reliable, timely, and professional service. We offer a wide range of vehicles, experienced drivers, and competitive prices for your Pune to Mumbai car hire, ensuring a comfortable and stress-free journey.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Harsh Agarwal",
            rating: 5,
            review: "I recently hired a car from Pune to Mumbai with Skyline Cabs. The entire experience was excellent. The car was clean, the driver was professional, and the ride was smooth. I’ll definitely be using them for future trips!"
        },
        {
            name: "Miss. Neha Deshmukh",
            rating: 4,
            review: "Great service overall! The ride was comfortable, and the driver was courteous. The only reason I gave 4 stars instead of 5 is that the car could have had more legroom. Otherwise, everything was perfect."
        },
    ];
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Mumbai Car Hire",
  "image": "https://skylinecabs.com/assets/images/pune-mumbai-car-hire.jpg",
  "description": "Hire a car from Pune to Mumbai with Skyline Cabs for a smooth and budget-friendly journey. Choose from well-maintained sedans, SUVs, and premium cars with driver service.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-mumbai-car-hire"
  }
};



      
    
      

    return (
        <div>

<Helmet>
  <title>Pune Mumbai Car Hire | AC Car with Driver | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Hire a car from Pune to Mumbai with Skyline Cabs for a smooth and budget-friendly journey. Choose from well-maintained sedans, SUVs, and premium cars with driver service." 
  />
  <meta 
    name="keywords" 
    content="Pune Mumbai Car Hire, Car Hire from Pune to Mumbai, Pune to Mumbai Car with Driver, AC Car Hire Pune to Mumbai, Sedan SUV Car Rental Pune Mumbai, One-Way Car Hire Pune to Mumbai, Affordable Car Hire Pune Mumbai, Premium Car Rental Pune to Mumbai, Skyline Cabs Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/5.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaicarhire;